module.exports = __webpack_public_path__ + "img/partner_1.85a38f9.png";